/*jslint white: true, nomen: true, unparam : true, es5: true */
/*global document, window, Cookies, jQuery */
(function ($) {
    "use strict";
    $(document).ready(function () {
        $('#btn-menu-mobile').click(function () {
            $('#menu-mobile').addClass('sel');
        });
        $('#menu-mobile .close').click(function () {
            $('#menu-mobile').removeClass('sel');
        });
        $('.btn-filter-mobile').click(function () {
            $('.filter-mobile').toggleClass('sel');
        });
    });
}(jQuery));
